import { SET_OBJECTS, SET_OBJECT } from "@stofloos/actions/crud";

const initialState = {};

const crud = (state = initialState, action) => {
	switch (action.type) {
		case SET_OBJECT:
			return {
				...state,
				[action.requestId]: action.append ? { ...state[action.requestId], ...action.objects } : action.objects
			};
		case SET_OBJECTS:
			return {
				...state,
				[action.requestId]: action.append
					? [...state[action.requestId], ...action.objects]
					: [...action.objects]
			};
		default:
			return state;
	}
};

export default crud;
